import { Navigate, useLocation } from 'react-router-dom'
import { ReactElement } from 'react'

import { Loader } from '@percent/lemonade'
import { useAuthState } from '@percent/partner-dashboard/common/hooks/useAuthState/useAuthState'

interface AuthorisedRouteProps {
  element: ReactElement
}

export function AuthorisedRoute({ element }: AuthorisedRouteProps): ReactElement {
  const { isAuthorised, isAuthorising, partner, user } = useAuthState()
  const { search } = useLocation()

  if (isAuthorising || (isAuthorised && (!partner || !user))) {
    return <Loader />
  }

  if (isAuthorised) {
    return element
  }

  return <Navigate to={`/signin${search}`} replace />
}
